(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
exports.captionVis = function() {
  $(".caption").each(function(){
    if ($(this).parent().hasClass('swiper-slide-active'))
    {
      $(this).removeClass('opacZero');
    }
    else {
      $(this).addClass('opacZero');
    }
  })
};


},{}],2:[function(require,module,exports){
var footerCart = require("./footerCart.js");

$(document).ready(function(){
  footerCart.footerCartReveal();

  $(window).load(function(){
  });

});
},{"./footerCart.js":4}],3:[function(require,module,exports){
exports.fadeButtonsInit = function() {
  setTimeout(function (){
    $("#viewTrailer, #getTheFilm").removeClass("opacZero");
  }, 1000);
};
},{}],4:[function(require,module,exports){
exports.footerCartReveal = function() {
  if ( $( ".cartInner").length ) {
    if ($(".cartSlide").visible(true)) {
      $("#footer").addClass('visible');
    } else {
    }
  }
};
},{}],5:[function(require,module,exports){
exports.footerProductReveal = function() {
  if ( $( ".productInner").length ) {
    if ($(".productInner").visible(true)) {
      $("#footer").addClass('visible');
    } else {
    }
  }
};
},{}],6:[function(require,module,exports){
exports.goBackInit = function() {
  $(".x").click(function() {
    window.history.back();
  });
};
},{}],7:[function(require,module,exports){
var slide = require("./slides.js");
var visibleBar = require("./visibleBar.js");
var mobileMenu = require("./mobileMenu.js");
var newSwiper = require("./newSwiper.js");
var tabs = require("./tabs.js");
var scrollUrl = require("./scrollUrl.js");
var perspective = require("./perspective.js");
var opacZero = require("./opacZero.js");
var fadeButtons = require("./fadeButtons.js");
var goBack = require("./goBack.js");
var caption = require("./caption.js");

$(document).ready(function(){
  scrollUrl.singlePageScroll();
  mobileMenu.reveal();
  goBack.goBackInit();
  visibleBar.toggleVisible();
  tabs.initTabs();
  perspective.perspectiveInit();
  fadeButtons.fadeButtonsInit();

  $(window).load(function(){
    opacZero.removeClass();
    slide.eachSlide();
    newSwiper.swiperInit();
    caption.captionVis();
  });

  $(window).on('beforeunload', function(){
    opacZero.addClass();
  });

  $(window).scroll(function(){
    perspective.perspectiveInit();
  });

  window.setInterval(function(){
    visibleBar.toggleVisible();
    slide.eachSlide();
  }, 100);

  window.setInterval(function(){
     caption.captionVis();
  }, 500);


  $('#email-form').on('submit',function(e){
    e.preventDefault()
    var emailAddress = encodeURIComponent($('#email').val());
    var baseURL = 'https://docs.google.com/forms/d/1OV-8E5be9SAO8MWKUjAw4LyacR_ii94ff0VzePaJgt0/formResponse?entry.28834532=';
    var submitRef = '&submit=submit';
    var submitURL = (baseURL + emailAddress + submitRef);
    $(this)[0].action=submitURL;
    $('#email').addClass('active').val('Thank You!');
    return true;
    //window.open(submitURL,"_blank");
  })
      
    

});

},{"./caption.js":1,"./fadeButtons.js":3,"./goBack.js":6,"./mobileMenu.js":8,"./newSwiper.js":9,"./opacZero.js":10,"./perspective.js":11,"./scrollUrl.js":13,"./slides.js":14,"./tabs.js":15,"./visibleBar.js":16}],8:[function(require,module,exports){
exports.reveal = function() {
  $("#menuP").click(function() {
    $(".right").toggleClass("mobileMenuVisible");
  });
  $('footer a').on('click',function(){
    $(".right").removeClass("mobileMenuVisible");
  })
}
},{}],9:[function(require,module,exports){
exports.swiperInit = function() {
  var swiper = new Swiper('.swiper-container', {
    pagination: '.swiper-pagination',
    paginationClickable: true,
    loop: true,
    nextButton: '.swiper-button-next',
    prevButton: '.swiper-button-prev',
  });
};
},{}],10:[function(require,module,exports){
exports.removeClass = function() {
  $("html").removeClass("opacZero");
  $("#container").removeClass("opacZero");
}

exports.addClass = function() {
  $("html").addClass("opacZero");
}
},{}],11:[function(require,module,exports){
var holdSlides

exports.perspectiveInit = function() {
  if(!holdSlides)
    holdSlides = $('.holdSlides');
  var scroll = $(window).scrollTop() - holdSlides.offset().top + (window.innerHeight / 2);
  if ( holdSlides.length ) {
    holdSlides.css({
      "-webkit-perspective-origin": "50% " +scroll+"px",
      "-moz-perspective-origin": "50% " +scroll+"px",
      "perspective-origin": "50% " +scroll+"px"
    });
  }
};
},{}],12:[function(require,module,exports){
var footerProduct = require("./footerProduct.js");

$(document).ready(function(){
  footerProduct.footerProductReveal();

  $(window).load(function(){
  });

});
},{"./footerProduct.js":5}],13:[function(require,module,exports){
exports.singlePageScroll = function() {
$('.single-page-nav').singlePageNav({
    // offset: $('.single-page-nav').outerHeight(),
    filter: ':not(.external)',
    updateHash: true,
    currentClass: 'active',
    beforeStart: function() {
        console.log('begin scrolling');
    },
    onComplete: function() {
        console.log('done scrolling');

    }
});
}
},{}],14:[function(require,module,exports){
exports.eachSlide = function() {
  $(".slide").each(function(){
    if ($(this).visible(true)) {
      $(this).children(".inner").addClass('zoomIn');
      $(this).children(".inner").removeClass('opacZero');
    } else {
      $(this).children(".zoomIn").addClass('opacZero');
      if ($(this).children(".inner").css('opacity') == 0) {
        $(this).children(".inner").removeClass('zoomIn');
      }
    }
  });
};
},{}],15:[function(require,module,exports){
exports.initTabs = function() {
  $( "#tabs" ).tabs();
};
},{}],16:[function(require,module,exports){
exports.toggleVisible = function() {
  if ( $( ".firstInner").length ) {
    if ($(".firstInner").visible(true)) {
      $("#footer").removeClass('visible');
      $(".tag").fadeIn()
    } else {
      $("#footer").addClass('visible');
      $(".tag").fadeOut()
    }
  }
};
},{}]},{},[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16]);
